import transcribedScreen from 'assets/png/aiScribeDrawerTranscribingBackground.png';
import { Heading, Stack, Text } from 'components';

import style from './transcribedScreen.module.scss';

const TranscribedScreen = () => {
  return (
    <Stack
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-end"
      boxSizing="border-box"
      className={style.wrapper}
      height="100%"
      pb="110px"
    >
      <img className={style.image} src={transcribedScreen} />
      <Stack
        mt="80px"
        maxWidth="225px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="12px"
        position="relative"
      >
        <Heading level={3} className={style.title}>
          We're on it!
        </Heading>
        <Text className={style.text}>Give us a few minutes to process your recording.</Text>
      </Stack>
    </Stack>
  );
};

export default TranscribedScreen;
